const InviteLayer = (() => {
    let $inviteEmplLayer;
    let inviteUrl;                                                                      // 초대 링크
    let _passJson = {};                                                            // props
    let userEmailList = [];                                                             // 중복 관리용 list
    let pageData = {PG_NO: 1, NEXT_YN: 'Y'};      // 전문 페이징
    let pageToken;                                                                      // google api 호출 시 페이징
    let timer;                                                                          // google user data 검색 시, 디바운싱 용 타이머
    let selectedUserList = [];                                                          // selected user list
    let isIntegrated;                                                                   // 연락처, 워크스페이스 연동 여부

    function toggleInviteEmplLayer(props) {
        GooglePeopleDirectory.isIntegrated().then(bool => { isIntegrated = bool });
        $inviteEmplLayer = $("#inviteEmployeeLayer2");
        if ($inviteEmplLayer.is(":visible")) {
            closeInviteEmplLayer();
        } else {
            openInviteEmplLayer(props);
        }
    }

    function closeInviteEmplLayer() {
        $inviteEmplLayer.css("display", "none");
        clearGoogleUserListUl(); // google user list 초기화
        changeEmailInviteView(); // email view 로 전환
        $inviteEmplLayer.find(".js-email-list li").remove(); // 입력된 이메일 초기화
        updateSubmitBtn();
        updateInputField();
    }

    async function drawGoogleUserList() {
        await setMenu();

        const $inviteGoogleView = $inviteEmplLayer.find("#inviteGoogleView");
        const $tryGoogleIntegratedView = $inviteEmplLayer.find("#tryGoogleIntegratedView");

        // user list 화면으로 변경
        if (!$inviteGoogleView.is(":visible")) {
            $tryGoogleIntegratedView.css('display', 'none');
            $inviteGoogleView.css('display', 'grid');
        }

        const $googleUserUl = $inviteEmplLayer.find('.js-google-user-list');
        if ($googleUserUl.children().length === 0) {
            $googleUserUl.removeClass('scroll-mask');
            $googleUserUl.append(`<div class="loading-area" style="margin: 110px 0;">
                        <div class="loading type2">
                            <i class="circle"></i>
                            <i class="circle"></i>
                            <i class="circle"></i>
                            <i class="circle"></i>
                            <i class="circle"></i>
                        </div>
                    </div>`);
        }

        // google api 호출 후 draw
        const isContacts = $inviteGoogleView.find('.js-dropdown-btn').attr('data-code') === 'contacts';
        const query = $inviteGoogleView.find('.js-search-input').val();
        if (isContacts) {
            GooglePeopleDirectory.getGooglePeopleUserList({
                userId: _passJson.USER_ID,
                pageToken,
                query
            }, successCallback, errorCallback);
        } else {
            GooglePeopleDirectory.getGoogleDirectoryUserList({
                userId: _passJson.USER_ID,
                pageToken,
                query
            }, successCallback, errorCallback);
        }

        async function successCallback(dat) {
            const {GPEOPLE_REC, GDIRECTORY_USER_REC, PAGE_TOKEN} = dat;

            // 최초 로드 또는 유저 검색 시, 중복 관리를 위한 유저 리스트 초기화
            if (pageToken === '') userEmailList = [];

            // pageToken, pageData["NEXT_YN"] 갱신
            pageToken = PAGE_TOKEN;
            if (!pageToken) pageData["NEXT_YN"] = "N";

            // draw
            await $googleUserUl.drawListHelper({
                pageData: pageData,
                nextYn: pageData["NEXT_YN"],
                records: GPEOPLE_REC ?? GDIRECTORY_USER_REC,
                noDataHtml: ListHelper.getNoDataHtml("SEARCH"),
                targetObj: {
                    scroll: $googleUserUl,
                },
                callback: {
                    item: (records) => {
                        return Array.from(records).map(user => getUserListHtml(user));
                    },
                    scroll: () => {
                        if (pageData["NEXT_YN"] === "N") return;
                        return drawGoogleUserList();
                    },
                    final: () => {
                        $googleUserUl.addClass('scroll-mask');
                        if (selectedUserList.length === 0) return;
                        $inviteEmplLayer.find('.js-google-invite-btn').addClass('active');
                        selectedUserList.forEach(email => {
                            $(`.js-member-select[email="${email}"]`).prop('checked', true);
                        });
                    }
                }
            })
        }

        async function errorCallback() {
            await GooglePeopleDirectory.disconnectIntegration();
            await changeGoogleInviteView({isIntegrate: false});
        }

        async function setMenu() {
            const $inviteGoogleView = $inviteEmplLayer.find("#inviteGoogleView");
            const useGoogleDirectoryYn = LocalUtil.getLocalJson("USE_GOOGLE_WORKSPACE_YN").GOOGLE_DIRECTORY;

            if (useGoogleDirectoryYn === 'N') return;
            if (useGoogleDirectoryYn === 'Y') return $inviteGoogleView.find('.js-dropdown-btn').css('display', '');

            GooglePeopleDirectory.getGoogleDirectoryUserList({userId: _passJson.USER_ID}, (dat) => {
                const {GDIRECTORY_USER_REC} = dat;
                if (GDIRECTORY_USER_REC.length !== 0) {
                    LocalUtil.setLocalValue('USE_GOOGLE_WORKSPACE_YN', 'GOOGLE_DIRECTORY', 'Y');
                    $inviteGoogleView.find('.js-dropdown-btn').css('display', '');
                } else {
                    LocalUtil.setLocalValue('USE_GOOGLE_WORKSPACE_YN', 'GOOGLE_DIRECTORY', 'N');
                }
            });
        }
    }

    function setIntegrationStatus(_isIntegrated) {
        isIntegrated = _isIntegrated;
    }


    function openInviteEmplLayer({isMain = false, passJson = {}}) {
        $inviteEmplLayer = $("#inviteEmployeeLayer2");
        _passJson = passJson;

        // data
        if (isMain) {
            Ajax.executeApi(RestApi.GET.FLOW_USE_INTT_INFM_R001, {}, function (data) {
                inviteUrl = getInviteUrl(data.SUB_DOM.toLowerCase());
                _passJson.USER_ID = window._USER_ID;
                _passJson.USER_NM = window._USER_NM;
                _passJson.SUB_DOM_NM = data.SUB_DOM_NM;
            })
        } else {
            inviteUrl = getInviteUrl(passJson.SUB_DOM_DATA.toLowerCase());
            // window._USER_ID 로 소켓 연결
            window._USER_ID = _passJson.USER_ID
        }

        // display
        $inviteEmplLayer.css("display", "block");
        const isMobile = _passJson.WEBVIEW_YN === "Y";
        const isManager = LocalUtil.getLocalJson('ONLY_COMPANY_JSON').isManager;
        if (isMobile || (isMain && !isManager)) {
            $inviteEmplLayer.find('.js-other-invite').remove();
        }

        // event
        addEvent();
    }

    function addEvent() {
        const $inviteEmailView = $inviteEmplLayer.find("#inviteEmailView");
        const $inviteGoogleView = $inviteEmplLayer.find("#inviteGoogleView");
        const $tryGoogleIntegratedView = $inviteEmplLayer.find("#tryGoogleIntegratedView");

        $inviteEmplLayer.off('click').on('click', (e) => {
            const $eTarget = $(e.target);

            closeApiChoicePopup($eTarget);
            if (isClosePopupBtn()) return;
            if (isStepBackBtn()) return;

            function isClosePopupBtn() {
                const $closePopupBtn = $eTarget.closest(".js-close-btn");
                const $logobtn = $eTarget.closest(".js-logo-display-wrap");
                if ($closePopupBtn.length === 0 && $logobtn.length === 0) return false;

                const {
                    mobileSignInFunc = Mutil.noop,
                    mobileCloseFunc = Mutil.noop,
                    WEBVIEW_YN = "N",
                    isSns,
                } = _passJson;
                const isWebView = WEBVIEW_YN === "Y";
                const isSignUp = Often.isAct("newSignup");

                // 1. 모바일 + 가입 중 직원초대 시
                if (isWebView && isSignUp) {
                    mobileSignInFunc();
                    return true;
                }
                // 2. 모바일 + 가입 후 직원초대 시
                if (isWebView && !isSignUp) {
                    mobileCloseFunc();
                    return true;
                }
                // 3. 웹 + 가입 중 직원초대 시
                if (!isWebView && isSignUp) {
                    CommonLogin.moveMainPage({firstLoginYn: "Y", desktopGuideYn: "Y", snsYn: isSns ? "Y" : "N"});
                    return true;
                }
                // 4. 웹 + 가입 후 main.act 에서 직원초대 시
                if (!isWebView && !isSignUp) {
                    closeInviteEmplLayer();
                    return true;
                }
            }

            function isStepBackBtn() {
                const $stepBackBtn = $eTarget.closest(".js-btn-step-back");
                if ($stepBackBtn.length === 0) return false;
                changeEmailInviteView();
                clearGoogleUserLi();
                updateGoogleInviteBtn();
            }
        })

        $inviteEmailView.off('click').on('click', (e) => {
            const $eTarget = $(e.target);

            if (isCopyInviteLinkBtn()) return;
            if (isOtherInviteBtn()) return;
            if (isEmailEnterBtn()) return;
            if (isEmailLiDelBtn()) return;
            if (isSubmitBtn()) return;
            if (isInviteGoogleBtn()) return;

            function isCopyInviteLinkBtn() {
                const $copyLinkBtn = $eTarget.closest(".js-copy-invite-link");
                if ($copyLinkBtn.length === 0) return false;
                copyLink();
                userTrack("copy-invitation-link-click");
                return true;
            }

            function isOtherInviteBtn() {
                const $otherInviteBtn = $eTarget.closest(".js-other-invite");
                if ($otherInviteBtn.length === 0) return false;
                window.open(`/${Often.getAdminPage()}?MENU=flow-invite-excel`, "admin_invite");
                userTrack("excel-invite-click");
                return true;
            }

            function isEmailEnterBtn() {
                const $enterBtn = $eTarget.closest(".js-enter-btn");
                if ($enterBtn.length === 0) return false;
                appendEmailLi();
                return true;
            }

            function isEmailLiDelBtn() {
                const $emailLiDelBtn = $eTarget.closest(".js-del-btn");
                if ($emailLiDelBtn.length === 0) return false;
                $emailLiDelBtn.closest('li').remove();
                updateSubmitBtn();
                updateInputField();
                return true;
            }

            function isSubmitBtn() {
                const $submitBtn = $eTarget.closest(".js-cont-btn");
                if ($submitBtn.length === 0) return false;

                const $emailInput = $inviteEmplLayer.find(".js-email-li");
                let emailList = [];
                $.each($emailInput, (i, li) => {
                     emailList.push({EML: $(li).text().trim()});
                });
                sendInviteMail(emailList);
            }

            function isInviteGoogleBtn() {
                const $inviteGoogleBtn = $eTarget.closest(".js-invite-google");
                if ($inviteGoogleBtn.length === 0) return false;
                changeGoogleInviteView({isIntegrate: true});
            }
        });

        $inviteEmailView.off('keyup').on('keyup', (e) => {
            if (isEnterKey()) return;

            function isEnterKey() {
                if (!KeyCheck.isKey(e, "ENTER")) return false;
                appendEmailLi();
                return true;
            }
        });

        $tryGoogleIntegratedView.off('click').on('click', (e) => {
            const $eTarget = $(e.target);

            if (isIntegratedBtn()) return;

            function isIntegratedBtn() {
                const $integratedBtn = $eTarget.closest(".js-integrated-btn");
                if ($integratedBtn.length === 0) return false;
                GooglePeopleDirectory.OAuthApiLoad(_passJson.USER_ID);
            }
        })

        $inviteGoogleView.off('click').on('click', (e) => {
            const $eTarget = $(e.target);

            if (isInviteBtn()) return;
            if (isDropdownBtn()) return;
            if (isDropdownMenuBtn()) return;
            if (isMemberSelectBtn()) return;

            function isInviteBtn() {
                const $googleInviteBtn = $eTarget.closest('.js-google-invite-btn');
                if ($googleInviteBtn.length === 0) return false;
                let emailList = [];
                selectedUserList.forEach((email) => {
                    emailList.push({EML: email});
                });
                sendInviteMail(emailList);
                return true;
            }

            function isDropdownBtn() {
                const $dropDownBtn = $eTarget.closest('.js-dropdown-btn');
                if ($dropDownBtn.length === 0) return false;

                $inviteGoogleView.find('.js-dropdown-menu').toggleClass('on');
                return true;
            }

            function isDropdownMenuBtn() {
                const $dropDownLi = $eTarget.closest('.js-dropdown-li');
                if ($dropDownLi.length === 0) return false;

                const $dropDownBtn = $inviteGoogleView.find('.js-dropdown-btn');
                $dropDownBtn.find('span').text($dropDownLi.text());
                $dropDownBtn.attr('data-code', $dropDownLi.data('code'));
                clearGoogleUserListUl();
                clearGoogleUserLi();
                updateGoogleInviteBtn();
                drawGoogleUserList();
                $inviteGoogleView.find('.js-dropdown-menu').toggleClass('on');
                return true;
            }

            function isMemberSelectBtn() {
                const $targetCheckbox = $eTarget.closest('.js-member-info-list').find('.js-member-select');
                if ($targetCheckbox.length === 0) return false;

                const isChecked = $targetCheckbox.is(":checked");
                const selectedUserEmail = $targetCheckbox.attr('email');
                if (isChecked) {
                    // selectedUserList 에서 제외 + check 해제
                    selectedUserList = selectedUserList.filter(email => email !== selectedUserEmail);
                    $targetCheckbox.prop('checked', false);
                } else {
                    // selectedUserList 에 추가 + check 처리
                    if (!selectedUserList.includes(selectedUserEmail)) {
                        selectedUserList.push(selectedUserEmail);
                    }
                    $targetCheckbox.prop('checked', true);
                }

                // [n명 선택] 버튼 update
                updateGoogleInviteBtn();
            }
        })

        $inviteGoogleView.off('keyup').on('keyup', (e) => {
            const $eTarget = $(e.target);

            if (isSearchInput()) return;

            function isSearchInput() {
                const $searchInput = $eTarget.closest('.js-search-input');
                if ($searchInput.length === 0) return false;

                timer && clearTimeout(timer);
                timer = setTimeout(async () => {
                    clearGoogleUserListUl();
                    drawGoogleUserList();
                }, 200);
                return true;
            }
        });
    }


    function getInviteUrl(subDom){
        let _url = location.protocol + '//';
        if (location.hostname.includes(subDom)) return _url += location.hostname + "/corpsignup.act";
        if (Mutil.isServerOn('ALL_TEST')) {
            return _url += location.hostname + '/corpsignup.act?invite=' + subDom;
        } else {
            return _url += `${subDom}.${location.hostname}/corpsignup.act`;
        }
    }

    function copyLink() {
        const invitedText = `${inviteUrl}?\n\n${i18next.t(common.invitingYou, {val: _passJson.USER_NM})}\n\n${i18next.t(common.invitingMsg, {val: _passJson.SUB_DOM_NM})}`;
        if (Often.isMobile() || Often.isTablet()) {
            navigator.clipboard.writeText(invitedText);
            Mutil.toast("success", i18next.t(common.alert.copiedToClipboard));
            return true;
        }
        Often.copyUrl(invitedText, i18next.t(common.copyInvitation));
    }

    function appendEmailLi() {
        const $emailListUl = $inviteEmplLayer.find('.js-email-list');
        const $emailInput = $inviteEmplLayer.find('.js-invite-email');
        const enteredEmail = $emailInput.val().trim();

        if (!checkEnteredEmail($inviteEmplLayer)) return;

        $emailListUl.append(`<li class='js-email-li'>
                                <span>${enteredEmail}</span>
                                <button class="btn-del js-del-btn"><i class="ic-ic-078-b"></i></button>
                            </li>`);
        $emailListUl.moveToBottom();
        $emailInput.val('');
        updateSubmitBtn();
        updateInputField();
    }

    function checkEnteredEmail() {
        const $emailListUl = $inviteEmplLayer.find('.js-email-list');
        const $emailInputWrap = $inviteEmplLayer.find('.js-input-wrap');
        const $emailErrorMsg = $inviteEmplLayer.find('.js-error-msg');
        const enteredEmail = $emailInputWrap.find('.js-invite-email').val().trim();
        const regExp = /^[0-9a-z]([-_.]?[a-z0-9])*@[a-z]([-_.]?[a-z0-9])*\.[a-z]+$/;
        const isValidEmail = regExp.test(enteredEmail);
        const isEmailExists = $emailListUl.find('li')
            .filter((index, li) => $(li).text().trim() === enteredEmail)
            .length > 0;

        if (isValidEmail && !isEmailExists) {
            $inviteEmplLayer.find('.js-input-wrap').removeClass('error');
            return true;
        }

        if (!isValidEmail) {
            $emailErrorMsg.text(i18next.t(common.pleaseCheckEmail));
        } else if (isEmailExists) {
            $emailErrorMsg.text(i18next.t(common.addedEmail));
        }
        $inviteEmplLayer.find('.js-input-wrap').addClass('error');
        return false;
    }

    function sendInviteMail(emailList) {
        if (emailList.length === 0) {
            return;
        }

        Ajax.executeApi(RestApi.POST.FLOW_TEAM_INVT_C001, {
            USER_ID: _passJson.USER_ID,
            EML_REC: emailList,
            RENEWAL_YN: "Y",
            SIGNUP_YN: "Y"
        }, () => {
            Often.toast("success", i18next.t(common.invitationSent));

            // 이메일 입력하여 초대 시, 이메일 리스트 등 초기화
            const $emailInput = $inviteEmplLayer.find('.js-email-li');
            if ($emailInput.length > 0) {
                $emailInput.remove();
                updateSubmitBtn();
                updateInputField();
                userTrack("email-invite-click");
                return;
            }

            // 구글 연락처로 초대 시, 선택된 유저 리스트 등 초기화
            const $checkedUser = $inviteEmplLayer.find('.js-member-select:checked');
            if ($checkedUser.length > 0) {
                $checkedUser.prop('checked', false);
                selectedUserList = [];
                userTrack("google-invite-click");
            }
            updateGoogleInviteBtn();
        });
    }

    function updateSubmitBtn() {
        const $emailListUl = $inviteEmplLayer.find('.js-email-list');
        const $submitBtn = $inviteEmplLayer.find('.js-cont-btn');
        const enteredEmailLength = $emailListUl.find('li').length
        if (enteredEmailLength === 0){
            $submitBtn.text(i18next.t(dictionary.send));
        } else {
            $submitBtn.text(i18next.t(common.sendToPeople, {val: enteredEmailLength}));
        }
    }

    function updateInputField(){
        const $emailListUl = $inviteEmplLayer.find('.js-email-list');
        const $emailInput = $inviteEmplLayer.find('.js-invite-email');
        if ($emailListUl.find('li').length === 8){
            $emailInput.attr('disabled', true);
            $emailInput.attr('placeholder', i18next.t(common.invitationEmailLimit));
        } else {
            $emailInput.attr('disabled', false);
            $emailInput.attr('placeholder', i18next.t(common.enterEmailAndPressEnter));
        }
    }

    function updateGoogleInviteBtn() {
        const $checkCountSpan = $inviteEmplLayer.find("#inviteGoogleView .js-check-count");
        const checkedCount = selectedUserList.length;
        if (checkedCount > 0) {
            $checkCountSpan.text(i18next.t(common.selectPeople, {val: checkedCount}));
            $inviteEmplLayer.find('.js-google-invite-btn').addClass('active');
        } else {
            $inviteEmplLayer.find('.js-google-invite-btn').removeClass('active');
        }
    }

    function changeGoogleInviteView({isIntegrate = false}) {
        const $inviteEmailView = $inviteEmplLayer.find("#inviteEmailView");
        const $inviteGoogleView = $inviteEmplLayer.find("#inviteGoogleView");
        const $tryGoogleIntegratedView = $inviteEmplLayer.find("#tryGoogleIntegratedView");

        $inviteEmplLayer.find('.js-logo-display-wrap').css('display', 'none');
        $inviteEmplLayer.find('.js-btn-step-back').css('display', 'block');
        $inviteEmailView.css('display', 'none');

        if (isIntegrated && isIntegrate) {
            clearGoogleUserListUl();
            drawGoogleUserList();
        } else {
            $inviteGoogleView.css('display', 'none');
            $tryGoogleIntegratedView.css('display', 'grid');
            if (isIntegrate) GooglePeopleDirectory.OAuthApiLoad(_passJson.USER_ID);
        }
    }

    function changeEmailInviteView() {
        const $inviteEmailView = $inviteEmplLayer.find("#inviteEmailView");
        const $inviteGoogleView = $inviteEmplLayer.find("#inviteGoogleView");
        const $tryGoogleIntegratedView = $inviteEmplLayer.find("#tryGoogleIntegratedView");

        $inviteEmplLayer.find('.js-logo-display-wrap').css('display', '');
        $inviteEmplLayer.find('.js-btn-step-back').css('display', 'none');
        $inviteEmailView.css('display', 'grid');
        $inviteGoogleView.css('display', 'none');
        $tryGoogleIntegratedView.css('display', 'none');
    }

    function getUserListHtml(user) {
        if (userEmailList.includes(user.EMAIL)) return;
        userEmailList.push(user.EMAIL);
        const defaultProfile = '/flow-renewal/assets/images/profile-default.svg';
        return `<li class="js-member-info-list">
                    <img src="${(user.PHOTO && (user.PHOTO !== '')) ? user.PHOTO : defaultProfile}" alt="" class="">
                    <div class="contact-txt">
                        <p>${user.NAME !== '' ? user.NAME : i18next.t(common.noName)}</p>
                        <span>${user.EMAIL}</span>
                    </div>
                    <div>
                        <input id="1" class="checkbox-item js-member-select" type="checkbox" email="${user.EMAIL}">
                        <label for="1"></label>
                    </div>
                </li>`;
    }

    function clearGoogleUserListUl(noDataHtml = '') {
        const $googleUserUl = $inviteEmplLayer.find('.js-google-user-list');
        $googleUserUl.html(noDataHtml);
        pageData = {PG_NO: 1, NEXT_YN: 'Y'};
        pageToken = '';
        closeApiChoicePopup();
    }

    function clearGoogleUserLi() {
        $inviteEmplLayer.find('.js-search-input').val('');
        selectedUserList = [];
    }

    function closeApiChoicePopup($eTarget) {
        if ($eTarget && $eTarget.closest('.js-dropdown-btn').length === 1) return;
        const $apiChoicePopup = $inviteEmplLayer.find('.js-dropdown-menu');
        $apiChoicePopup.removeClass('on');
    }

    function userTrack(event) {
        if (!event) return;
        const UserTracker = requireModule('userTracker', {on: ['signup']})();
        UserTracker?.InviteEmplUserTracker()?.track(event, {});
    }

    return {
        toggleInviteEmplLayer: toggleInviteEmplLayer,
        drawGoogleUserList: drawGoogleUserList,
        setIntegrationStatus: setIntegrationStatus,
    }
})();
